import React, { ReactNode } from 'react';
import { css } from '@emotion/react';
import { token } from '@atlaskit/tokens';

interface NavBarMenuItemProps {
  /** Header content to be displayed */
  headerContent: ReactNode;
  /** (optional) Content to be displayed if/when the link is active, only in mobile/tablet view */
  bodyContent?: ReactNode;
  /** (optional) True if this link item is nested under another link item, applies only to mobile/tablet view */
  isNested?: boolean;
  /** (optional) True if this link item is active, applies only to mobile/tablet view */
  isActive?: boolean;
}

export const NavBarItemWithMenu: React.FC<NavBarMenuItemProps> = ({
  headerContent,
  bodyContent,
  isNested = false,
  isActive = false,
}) => (
  <div css={containerStyles} role="group" data-testid="navbar-menu-item">
    <div css={[headerStyles, isActive && headerSelectedStyles, isNested && nestedHeaderStyles]} role="treeitem">
      {headerContent}
    </div>
    {isActive && bodyContent && (
      <ul css={[bodyContentContainerStyles, isNested && nestedBodyContentContainerStyles]}>{bodyContent}</ul>
    )}
  </div>
);

const containerStyles = css({
  display: 'flex',
  fontSize: '16px',
  alignItems: 'flex-start',
  flexDirection: 'column',
  width: '100%',
});

const headerStyles = css({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  cursor: 'pointer',
  height: '32px',
  width: '100%',
  padding: `0 ${token('space.300')}`,
});

const headerSelectedStyles = css({
  color: token('color.text.selected'),

  'a, span': {
    color: token('color.text.selected'),
  },
});

const nestedHeaderStyles = css({
  padding: `0 ${token('space.500')}`,
});

const bodyContentContainerStyles = css({
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  gap: token('space.100'),
  paddingLeft: 0,
  margin: 0,
  marginTop: `${token('space.100')} !important`,
  listStyle: 'none',
});

const nestedBodyContentContainerStyles = css({
  li: {
    paddingLeft: '56px',
  },
});
